import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import React, { useState } from "react";
import type { ContactEntryFieldErrors } from "../../utils/contactEntryValidation";
import { isValidContactEmail } from "../../utils/contactEntryValidation";
import "./ContactEntryDialogs.scss";

import {
  useCheckExistOrNotMutation

} from "../../utils/apiSlice";
export type ContactEntryKind = "email" | "phone" | null;

type ContactEntryDialogsProps = {
  kind: ContactEntryKind;
  onClose: () => void;
  /** Guest sidebar / inline flows: keep parent background visible (no dimmed overlay). */
  subtleBackdrop?: boolean;
  /** When false (e.g. Login), phone step only asks for mobile — name is collected on verify-otp. Default true. */
  phoneCollectFullName?: boolean;
  draftFullName: string;
  onDraftFullNameChange: (v: string) => void;
  draftEmail: string;
  onDraftEmailChange: (v: string) => void;
  draftPhone: string;
  onDraftPhoneChange: (v: string) => void;
  fieldErrors: ContactEntryFieldErrors;
  onClearContactFieldError: (field: "name" | "email" | "phone") => void;
  onEmailNext: () => void;
  onPhoneNext: () => void;
  checkUser: (value: boolean) => void;
  isExistingUser: boolean | null;
};

/** Same email/phone entry modals as Register — reusable from Login / RegisterModal via navigation or direct render. */
export default function ContactEntryDialogs({
  kind,
  onClose,
  subtleBackdrop = false,
  phoneCollectFullName = true,
  draftFullName,
  onDraftFullNameChange,
  draftEmail,
  onDraftEmailChange,
  draftPhone,
  onDraftPhoneChange,
  fieldErrors,
  onClearContactFieldError,
  onEmailNext,
  onPhoneNext,
  checkUser,
  isExistingUser
}: ContactEntryDialogsProps) {

  const [verifyUser] = useCheckExistOrNotMutation();


  const handlePhoneChange = async (value: string) => {
    const clean = value.replace(/\D/g, "").slice(0, 10);
    onClearContactFieldError("phone");
    onDraftPhoneChange(clean);

    if (clean.length === 10) {
      try {
        const res = await verifyUser({

          userName: `+91${clean}`,
        }).unwrap();

        checkUser(res.data);
        console.log(res)
      } catch (err) {
        checkUser(false);
        console.error(err);
      }
    }else{
        checkUser(true);
    }
  };


  const handleEmailChange = async (value: string) => {
    value = value.replace(/\s/g, "");
    onClearContactFieldError("email");
    onDraftEmailChange(value);

    // call only if valid email pattern
    if (isValidContactEmail(value)) {
      try {
        const res = await verifyUser({

          userName: value,
        }).unwrap();

        checkUser(res.data);
      } catch (err) {
        checkUser(false);
        
      }
    }else{
        checkUser(true);
    }
  };


  return (
    <Dialog
      open={kind !== null}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      className="auth-modal glass-modal register-contact-entry-dialog"
      BackdropProps={{
        style: subtleBackdrop
          ? { backgroundColor: "transparent", backdropFilter: "none" }
          : {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            backdropFilter: "blur(5px)",
          },
      }}
    >
      <IconButton
        className="auth-modal-round-close"
        aria-label="close"
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent
        className={`register-contact-entry-content pt-40 pb-20 px-30 ${kind === "phone" ? "register-contact-entry-content--phone" : ""
          }`}
      >
        {kind === "email" && (
          <>
            <div className="register-contact-header">
              <h2 className="register-contact-entry-title register-contact-entry-title--compact">
                Verify Email Address
              </h2>
              <p className="register-contact-subtitle">Enter your details to get the OTP</p>
            </div>

            <div className="register-contact-stack register-contact-stack--phone">
              <div className="register-contact-phone-row">
                <input
                  style={{ paddingLeft: '0rem' }}
                  type="email"
                  className={`register-contact-email-input ${fieldErrors.email ? "is-invalid" : ""}`}
                  placeholder="you@gmail.com"
                  value={draftEmail}
                  onChange={(e) => handleEmailChange(e.target.value)}

                  onKeyDown={(e) => {
                    if (e.key === " ") e.preventDefault();
                  }}
                  autoComplete="email"

                />
                {draftEmail.length > 0 && (
                  <button
                    type="button"
                    className="register-contact-clear"
                    aria-label="Clear"
                    onClick={() => {
                      onDraftEmailChange("");
                      onClearContactFieldError("email");
                        checkUser(true);
                    }}
                  >
                    ×
                  </button>
                )}
              </div>
            </div>

            {fieldErrors.email ? (
              <p className="text-danger small register-contact-inline-error">{fieldErrors.email}</p>
            ) : null}


            {!isExistingUser && <div className="register-contact-stack register-contact-stack--phone">

              <div className="register-contact-phone-row">
                <input style={{ paddingLeft: '0rem' }}
                  type="text"
                  className={`register-contact-name-input ${fieldErrors.name ? "is-invalid" : ""}`}
                  placeholder="Full name"
                  value={draftFullName}

                
                     onChange={(e) => {
                        let value = e.target.value;

                      
                        value = value.replace(/[^a-zA-Z\s]/g, "");

                      
                        value = value.trimStart();

                     onClearContactFieldError("name");
                    onDraftFullNameChange(value);
                      }}
                
                  autoComplete="name"

                />
                {draftFullName.length > 0 && (
                  <button
                    type="button"
                    className="register-contact-clear"
                    aria-label="Clear"
                    onClick={() => {
                      onDraftFullNameChange("");
                      onClearContactFieldError("name");
                    }}
                  >
                    ×
                  </button>
                )}
              </div>
            </div>}
            {fieldErrors.name && isExistingUser === false && (
              <p className="text-danger small register-contact-inline-error">{fieldErrors.name}</p>
            )}

            <p className="register-contact-hint mb-1">
              We&apos;ll send you a code to confirm your email address.
            </p>
            <p className="register-contact-hint-muted mb-4">
              We may occasionally send you service-based messages.
            </p>
            <div className="register-contact-actions">
              <button type="button" className="btn btn-primary px-40" onClick={onEmailNext}>
                Next
              </button>
            </div>
          </>
        )}
        {kind === "phone" && (
          <>
            <div className="register-contact-header">
              <h2 className="register-contact-entry-title register-contact-entry-title--compact">
                Verify Phone Number
              </h2>
              <p className="register-contact-subtitle">
                {phoneCollectFullName ? "Enter your details to get the OTP" : "Enter your mobile number to get the OTP"}
              </p>
            </div>

            <div className="register-contact-stack register-contact-stack--phone">
              <div className="register-contact-phone-row">
                <input
                  type="tel"
                  inputMode="numeric"
                  className={`register-contact-phone-input ${fieldErrors.phone ? "is-invalid" : ""}`}
                  placeholder="Enter 10 digit number"
                  value={draftPhone}

                  onChange={(e) => handlePhoneChange(e.target.value)}
                  // autoFocus={!phoneCollectFullName}
                  autoComplete="tel-national"
                />
                {draftPhone.length > 0 && (
                  <button
                    type="button"
                    className="register-contact-clear"
                    aria-label="Clear"
                    onClick={() => {
                      onDraftPhoneChange("");
                      onClearContactFieldError("phone");
                           checkUser(true);
                    }}
                  >
                    ×
                  </button>
                )}
              </div>
            </div>
            {fieldErrors.phone ? (
              <p className="text-danger small register-contact-inline-error">{fieldErrors.phone}</p>
            ) : null}

            {phoneCollectFullName ? (
              <>
                {!isExistingUser && <div className="register-contact-stack register-contact-stack--phone">
                  <div className="register-contact-phone-row">
                    <input
                      style={{ paddingLeft: '0rem' }}
                      type="text"
                      className={`register-contact-name-input ${fieldErrors.name ? "is-invalid" : ""}`}
                      placeholder="Full name"
                      value={draftFullName}
                    


                       onChange={(e) => {
                        let value = e.target.value;

                      
                        value = value.replace(/[^a-zA-Z\s]/g, "");

                      
                        value = value.trimStart();

                        onClearContactFieldError("name");
                        onDraftFullNameChange(value);
                      }}
                      // autoFocus
                      autoComplete="name"
                    />
                    {draftFullName.length > 0 && (
                      <button
                        type="button"
                        className="register-contact-clear"
                        aria-label="Clear"
                        onClick={() => {
                          onDraftFullNameChange("");
                          onClearContactFieldError("name");
                        }}
                      >
                        ×
                      </button>
                    )}
                  </div>
                </div>}
                {fieldErrors.name && isExistingUser === false && (
                  <p className="text-danger small register-contact-inline-error">{fieldErrors.name}</p>
                )}
              </>
            ) : null}


            <p className="register-contact-hint mb-1">
              We&apos;ll send you a code to confirm your phone number.
            </p>
            <p className="register-contact-hint-muted mb-4">
              We may occasionally send you service-based messages.
            </p>
            <div className="register-contact-actions">
              <button type="button" className="btn btn-primary px-40" onClick={onPhoneNext}>
                Send
              </button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
